<template>
    <div class="sample" v-if="$route.meta.showSample">
        <a-breadcrumb separator=">">
            <a-breadcrumb-item>
                <router-link to="/home">
                    <img src="../../assets/home/icon-home.svg" style="margin: 0 4px 4px 0" />首页
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>{{ currentSubtitle }}</a-breadcrumb-item>
        </a-breadcrumb>

        <div class="sample-body">
            <submenu-tabs title="查询服务" :tabs="leftTab" @changeTab="tabChanged" :propActive="currentSubtitle" />

            <div class="right-content">
                <router-view @change="changePage"></router-view>
            </div>
        </div>
    </div>
    <router-view class="sample" v-else></router-view>
</template>

<script>
import SubmenuTabs from '../../components/submenu-tabs.vue';

export default {
    components: { SubmenuTabs },

    data() {
        return {
            leftTab: [
                { name: '控制样订购', id: 'sampleOrder' },
                { name: '控制样查询', id: 'sampleSearch' }
            ],
            currentSubtitle: '控制样订购',
            currentSubid: 'sampleOrder'
        };
    },
    mounted() {
        this.$router.push({ name: this.currentSubid });
    },
    methods: {
        tabChanged(tab) {
            this.currentSubtitle = tab.name;
            this.currentSubid = tab.id;
            this.$router.push({ name: tab.id });
        },

        changePage(val) {
            if (val) {
                this.currentSubid = val;
                this.currentSubtitle = this.leftTab.find(item => item.id === val).name;
                this.$router.push({ name: val });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.sample {
    width: 1200px;
    padding-bottom: 94px;

    &-body {
        display: flex;
        align-items: flex-start;

        .submenu-tabs {
            flex-shrink: 0;
        }

        .right-content {
            width: 892px;
            margin-left: 16px;
            border-radius: 4px;
        }
    }
}
</style>
